import React from 'react';
import PropTypes from 'prop-types';
import { theme } from '~/styles/theme';

export default function DoubleYellowIcon({ size, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 92 113" {...rest}>
      <path
        fill={theme.yellow}
        d="M90.8923767,82.5739987 L92,83.6465445 C91.5560538,87.0608153 90.7623318,90.4616793 89.573991,93.7642266 C87.4529148,99.7123869 84.1210762,105.356659 79.7757848,110.276963 L77.7533632,112.573999 L73,107.962052 L75.3856502,106.018062 C79.9237668,102.326717 83.8161435,97.7594597 86.7309417,92.5531436 C88.4887892,89.4293539 89.8878924,86.0687104 90.8923767,82.5739987 Z M75.4274,32.1935587 L75.4274,94.5691587 L28.5806,94.5691587 L28.5806,86.2307587 L65.6302,86.2307587 L65.6302,32.1935587 L75.4274,32.1935587 Z M61.7522,18.9691587 L61.7522,82.4591587 L15.0706,82.4591587 L15.0706,18.9691587 L61.7522,18.9691587 Z M56.752,23.9689987 L20.07,23.9689987 L20.07,77.4589987 L56.752,77.4589987 L56.752,23.9689987 Z M13.5954885,-1.61648472e-13 L18.5094522,4.91396373 L16.1955117,6.82823524 C11.803855,10.4664175 8.08607014,15.0294041 5.36390724,20.2806203 C3.72111594,23.4369125 2.45227546,26.8416892 1.57467321,30.4055916 L0.431357649,29.262276 C0.752732781,25.7632044 1.42408396,22.2941698 2.48242216,18.9360966 C4.38287241,12.888261 7.50569134,7.19707698 11.6582851,2.29100873 L13.5954885,-1.61648472e-13 Z"
      />
    </svg>
  );
}

DoubleYellowIcon.propTypes = {
  size: PropTypes.number,
};

DoubleYellowIcon.defaultProps = {
  size: 15,
};
